// The one text-matching rule every portal picker narrows by.
//
// It is deliberately the SAME rule Nexus applies server-side to the company item
// master (nexus_erp/packages/backend/src/services/portalItemSearchService.ts,
// which mirrors nexus_erp/packages/frontend/src/utils/searchUtils.ts): split the
// query on whitespace and require EVERY token to appear somewhere in the row's
// searchable text. A picker that narrowed by a different rule than the endpoint
// feeding it would drop rows the server had just returned as matches — the
// customer types a second word and the item they can see disappears.
//
// A substring rule and not fuzzy scoring, because a partner searching their own
// stock knows what it is called: "grip 6" has to find "Grip6", and nothing else
// should outrank an exact SKU.
export function tokenizeSearch(query) {
    if (typeof query !== 'string')
        return [];
    return query.trim().toLowerCase().split(/\s+/).filter(Boolean);
}
// True when every token appears in the joined haystack. No tokens matches
// everything, which is what makes an empty search box mean "show the list".
export function matchesAllTokens(haystack, tokens) {
    if (tokens.length === 0)
        return true;
    const text = haystack
        .filter((v) => typeof v === 'string' && v.length > 0)
        .join(' ')
        .toLowerCase();
    return tokens.every((t) => text.includes(t));
}
//# sourceMappingURL=search-tokens.js.map